/**
 * Shared duplicate-listing pre-flight for any flow that assigns a listing ID
 * to a floor plan (attach modal, link-by-url, inline edit).
 */

export const buildLinksByCustomerRef = (existingLinks) => {
  const map = new Map();
  (Array.isArray(existingLinks) ? existingLinks : []).forEach((link) => {
    const ref = link?.customer_ref;
    if (!ref) return;
    map.set(String(ref).trim(), link);
  });
  return map;
};

/**
 * @returns {null | { ref, priorLinkId, priorPlanName, priorPlanThumb, priorLayoutUuid }}
 */
export const getReplaceCandidateForListingRef = ({
  listingRef,
  layoutUuid,
  linksByRef,
  planByCustomerRef,
}) => {
  const ref = String(listingRef || '').trim();
  if (!ref) return null;

  const priorLink = linksByRef?.get?.(ref);
  if (!priorLink) return null;

  const priorUuid = priorLink.layoutUuid;
  if (priorUuid && layoutUuid && priorUuid === layoutUuid) {
    return null;
  }

  const priorPlan = planByCustomerRef?.get?.(ref) || null;
  return {
    ref,
    priorLinkId: priorLink._id || priorLink.id,
    priorPlanName: priorPlan?.name || null,
    priorPlanThumb: priorPlan?.thumbnail || null,
    priorLayoutUuid: priorUuid || null,
  };
};
